<div class="main-content mt-16">
  <div class="px-4 pb-3 lg:pt-3">
    <h1 class="font-bold text-5xl md:text-6xl pb-2">Document Review</h1>
    <ng-container>
      <form class="mt-1" [formGroup]="searchForm">
        <div class="mt-1 flex justify-between">
          <div class="flex">
            @if (fullInvestorList?.length > 0) {
              <div class="me-2">
                <mat-form-field appearance="outline" class="form-field review-filter-field">
                  <mat-select formControlName="investors" multiple #investorSelect placeholder="Investors"
                    disableOptionCentering panelClass="mat-select-investors">
                    <mat-option>
                      <ngx-mat-select-search [formControl]="investorSearch" placeholderLabel="Search"
                      noEntriesFoundLabel="No Investors Found"></ngx-mat-select-search>
                    </mat-option>
                    @for (investor of searchedInvestorList; track investor) {
                      <mat-option (click)="investorOptionClick(investor.id)"
                        [value]="investor.id">{{investor.name}}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            }
            @if (fullPortfolioList?.length > 0) {
              <div class="ms-2 me-2">
                <mat-form-field appearance="outline" class="form-field review-filter-field">
                  <mat-select formControlName="portfolios" multiple #portfolioSelect
                    placeholder="Portfolios" disableOptionCentering panelClass="mat-select-portfolios">
                    <mat-option>
                      <ngx-mat-select-search [formControl]="portfolioSearch" placeholderLabel="Search"
                      noEntriesFoundLabel="No Portfolios Found"></ngx-mat-select-search>
                    </mat-option>
                    @for (portfolio of searchedPortfolioList; track portfolio) {
                      <mat-option (click)="portfolioOptionClick(portfolio.id)"
                      [value]="portfolio.id">{{portfolio.ticker}} - {{portfolio.name}}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            }

            <div class="ms-2 me-2 select-date-range">
                <gcm-date-picker [customDateSelect]="true" [quarterSelect]="true"
                    [date]="documentDatesFilter" [dateLabel]="'Document Date'" [multiSelect]="true"
                    (changedDate)="updateDocumentDatesFilter($event)" class="search-select-field period-date-selection"/>
            </div>

            <div class="ms-2 me-2 select-date-range">
                <gcm-date-picker [dateRangeSelect]="true" [dateOptionList]="dateRangeList"
                    [date]="reportGenerationDateFilters" [dateLabel]="'Generation Date'"
                    (dateChange)="updateGenerationDateFilter($event)"
                    [startDate]="gmtGenerationStartDate?.toString()" [endDate]="gmtGenerationEndDate?.toString()"
                    class="search-select-field"></gcm-date-picker>
            </div>

            <div class="ms-2 me-2">
              <mat-form-field appearance="outline" class="form-field review-filter-field">
                <mat-select formControlName="statusFilter" multiple #statusSelect
                  placeholder="Report Status" disableOptionCentering>
                  @for (statusOption of statusOptions; track statusOption) {
                    <mat-option
                    [value]="statusOption.value">{{statusOption.display}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="flex btn-group">
            <div>
              <button class="clear-btn" (click)="clearFilters()">
              Clear Filters </button>
            </div>
            <div>
              <button type="submit" class="submit-btn" (click)="applyFilters()"> Apply </button>
            </div>
          </div>
        </div>

        <div class="mb-4">
          <mat-chip-set>
            @for (selectedFilter of allFilters; track selectedFilter) {
              <mat-chip class="filter-chip"
                (removed)="removeFilter(selectedFilter)">
                {{ selectedFilter }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>
            }
            @for (investorFilter of investorFiltersNames; track investorFilter) {
              <mat-chip class="filter-chip"
                (removed)="removeInvestorFilter(investorFilter)">
                {{ investorFilter }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>
            }
            @for (portfolioFilter of portfolioFiltersNames; track portfolioFilter) {
              <mat-chip class="filter-chip"
                (removed)="removePortfolioFilter(portfolioFilter)">
                {{ portfolioFilter }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>
            }
          </mat-chip-set>
        </div>
      </form>
    </ng-container>
    <div class="card document-review-card">
      <div class="card-body p-0">
        <table mat-table matSort [dataSource]="dataSource" (matSortChange)="onSortChange($event)"
            class="mx-auto w-full" multiTemplateDataRows>
            <!-- Investor Name Column -->
            <ng-container matColumnDef="investorName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="w-[20%]"> Investor Name
                </th>
                <td mat-cell *matCellDef="let element" class="w-[20%]">{{element.investorName}}
                </td>
            </ng-container>

            <!-- Portfolio Name Column -->
            <ng-container matColumnDef="portfolioName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="w-[20%]"> Portfolio Name
                </th>
                <td mat-cell *matCellDef="let element" class="w-[20%]">{{element.portfolioName}}
                </td>
            </ng-container>

            <!-- Report Status Column -->
            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="w-[10%]"> Report Status
                </th>
                <td mat-cell *matCellDef="let element" class="w-[10%]">{{element.displayStatus}}
                </td>
            </ng-container>

            <!-- Report Generation Error Column -->
            <ng-container matColumnDef="error">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="w-[20%]"> Report Generation Error
                </th>
                <td mat-cell *matCellDef="let element" class="w-[20%]">{{element.error}}</td>
            </ng-container>

            <!-- Document Date of Report Column -->
            <ng-container matColumnDef="reportingPeriod">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="w-[10%]">
                    Document Date </th>
                <td mat-cell *matCellDef="let element" class="w-[10%]">
                    {{element.reportingPeriod | date: 'MM/dd/yyyy'}}
                </td>
            </ng-container>

            <!-- Report Generation Attempted Date Column -->
            <ng-container matColumnDef="createdOn">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="w-[10%]">
                    Attempted Generation Date </th>
                <td mat-cell *matCellDef="let element" class="w-[10%]">
                    {{element.createdOn | date: 'MM/dd/yyyy'}}
                </td>
            </ng-container>

            <!-- Document Retry Column -->
            <ng-container matColumnDef="retry">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="w-[10%]"></th>
                <td mat-cell *matCellDef="let element" class="w-[10%]">
                  <div class="flex btn-group">
                    <button class="submit-btn" (click)="retryDocumentGeneration(element.id)" data-cy="retryButton"> Retry </button>
                  </div>
                </td>
            </ng-container>

            <!-- Expanded Row: Stack Trace -->
            <ng-container matColumnDef="expandedDetail">
              <td *matCellDef="let element" [attr.colspan]="displayedColumns.length" class="p-4">
                  @if (element.expanded) {
                  <div class="text-white" animate.enter="detail-expand-enter" animate.leave="detail-expand-leave">
                    <div class="font-bold">Stack Trace:</div>
                    <pre class="whitespace-pre-wrap break-words overflow-hidden max-w-full">{{element.stackTrace || "No Stack Trace Available"}}</pre>
                  </div>
                  }
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let element; columns: displayedColumns; let i = dataIndex"
                (click)="element.expanded = !element.expanded;" class="pointer"
                [class]="{'bg-background-color-off-white': dataSource.indexOf(element) % 2 === 0, 'bg-white': dataSource.indexOf(element) % 2 === 1}"></tr>
            <tr mat-row *matRowDef="let element; columns: ['expandedDetail']"
                  class="bg-charcoal-grey" [class]="{'hidden': !element.expanded}"></tr>
            <tr class="mat-row text-center" *matNoDataRow>
                <td class="mat-cell" [attr.colspan]="displayedColumns.length">
                    No documents found
                </td>
            </tr>
        </table>
        <mat-paginator [length]="documents.totalCount" [pageSizeOptions]="pageSizes"
          [showFirstLastButtons]="true" [pageSize]="pageSize" [pageIndex]="page" aria-label="Select page"
          (page)="onPaginateChange($event)" class="mat-paginator-sticky">
        </mat-paginator>
      </div>
    </div>
  </div>
</div>